/** Identifies which upsell call-to-action was clicked, sent as `name` with `GtmEvent.upsell_clicked` */
export enum UpsellKey {
    /** Dashboard usage card, under 50% of the monthly order limit */
    USAGE_ON_TRACK = 'usage_on_track',
    /** Dashboard usage card, 50% up to 75% */
    USAGE_RUNNING_LOW = 'usage_running_low',
    /** Dashboard usage card, 75% up to 100% */
    USAGE_ALMOST_FULL = 'usage_almost_full',
    /** Dashboard usage card, 100% or more */
    USAGE_LIMIT_REACHED = 'usage_limit_reached',
    /** App inactive because more carriers are active than the plan allows */
    PROVIDER_LIMIT_EXCEEDED = 'provider_limit_exceeded',
    /** Shipping providers page, the plan's carrier limit is reached */
    ACTIVATED_PROVIDERS_LIMIT_REACHED = 'activated_providers_limit_reached',
    /** Wizard service-provider step, the selection would exceed the plan's carrier limit */
    WIZARD_SERVICE_PROVIDER_LIMIT = 'wizard_service_provider_limit',
    /** Billing thank-you page, plan change needs attention */
    PLAN_CHANGE = 'plan_change',
    /** Fulfillment service switch locked behind a higher plan */
    THIRD_PARTY_FULFILLMENT_LOCK = 'third_party_fulfillment_lock',
    /** Smart Delivery Page "Hide Powered by PickupBird" switch locked behind a higher plan */
    HIDE_POWERED_BY_LOCK = 'hide_powered_by_lock',
}
